import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting';
import {
  GetOfficerListQueryParamsType,
  GetOfficerListQueryResponseType,
} from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getOfficerList/getOfficerListQuery.type';

export const getOfficerListFunction = (
  params: GetOfficerListQueryParamsType,
): Promise<PaginationResponseType<GetOfficerListQueryResponseType[]>> => {
  return fetchApi.get('selection_item/officers_list/list/', {
    params: { ...params, page_size: 15 },
  });
};
